import React, { forwardRef } from "react";

// Pure CSS transition wrapper — no external animation library needed
const MotionDiv = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & Record<string, any>>(
  ({ initial, animate, exit, transition, whileHover, whileTap, whileInView, viewport, variants, onAnimationComplete, layout, layoutId, mode, ...props }, ref) => {
    return <div ref={ref} {...props} />;
  }
);
MotionDiv.displayName = "MotionDiv";

const AnimatePresence = ({ children }: { children: React.ReactNode; mode?: string }) => <>{children}</>;

const motion = {
  div: MotionDiv,
  span: MotionDiv,
  section: MotionDiv,
  article: MotionDiv,
  nav: MotionDiv,
  main: MotionDiv,
  header: MotionDiv,
  footer: MotionDiv,
  aside: MotionDiv,
  ul: MotionDiv,
  li: MotionDiv,
  p: MotionDiv,
  a: MotionDiv,
  button: MotionDiv,
  form: MotionDiv,
  img: MotionDiv,
  h1: MotionDiv,
  h2: MotionDiv,
  h3: MotionDiv,
  h4: MotionDiv,
  h5: MotionDiv,
  h6: MotionDiv,
};

export function useMotion() {
  return {
    motion,
    AnimatePresence,
    isFramerMotion: false,
  };
}
